export const ethnicityOptions = [
  { label: "Asian", value: "asian" },
  { label: "Black or African American", value: "black_or_african_american" },
  { label: "Hispanic or Latino", value: "hispanic_or_latino" },
  {
    label: "Native American or Alaska Native",
    value: "native_american_or_alaska_native",
  },
  {
    label: "Native Hawaiian or Other Pacific Islander",
    value: "native_hawaiian_or_pacific_islander",
  },
  { label: "White", value: "white" },
  { label: "Two or More Races", value: "two_or_more_races" },
  { label: "Other", value: "other" },
  { label: "Prefer not to say", value: "prefer_not_to_say" },
];

export const perPage: number = 10;

export interface LanguageInfo {
  label: string;
  rtl?: boolean;
}

export const languages: Record<string, LanguageInfo> = {
  "en":     { label: "English" },
  "he":     { label: "Hebrew", rtl: true },
  "ko":     { label: "Korean" },
  "ms":     { label: "Malay" },
  "my":     { label: "Burmese" },
  "th":     { label: "Thai" },
  "vi":     { label: "Vietnamese" },
  "zh-CN":  { label: "Chinese" },
  "zh-TW":  { label: "Taiwanese" },
} as const;

export type SupportedLanguage = keyof typeof languages;
